// Styles for Footer go here.
import styled from 'styled-components';
import { theme } from '../../../styles';

export const StyledHeader = styled.header<{
  isAuthorMode: boolean;
}>`
  &.lt-header {
    overflow: hidden;
    top: 0;
    position: ${({ isAuthorMode }) => (isAuthorMode ? 'static' : 'fixed')};
    width: ${({ isAuthorMode }) => (isAuthorMode ? 'auto' : '100vw')};
    z-index: 1000;
    a:focus-visible {
      outline: 1px solid transparent;
    }
  }

  &.lt-header .lt-back {
    background-color: ${theme.colors.coral};
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    padding: 7px 64px;
    display: flex;
    justify-content: center;

    &:has(.right-container) {
      justify-content: space-between;
    }
  }
  &.lt-header .lt-back a {
    display: flex;
    align-items: center;
    gap: 5px;
    color: ${theme.colors.black};
    cursor: pointer;
  }
  &.lt-header .lt-back a svg {
    transform: rotate(-180deg);
  }
  &.lt-header .lt-back a span {
    text-decoration: underline;
  }
  .lt-header-inner {
    padding: 10px 0 0;
    background-color: ${theme.colors.white};
  }
  @media ${theme.ltMediaQuery.tablet} {
    .lt-header-inner {
      padding-top: 13px;
      padding-bottom: 13px;
    }
  }
  &.lt-header .logo {
    margin-left: 20px;
    width: 140px;
    height: 39px;
  }
  @media ${theme.ltMediaQuery.tablet} {
    &.lt-header .logo {
      margin-left: 35px;
      width: 180px;
      height: 50px;
    }
  }
  &.lt-header nav {
    display: flex;
    width: 100%;
    gap: 30px;
    padding: 10px 20px;
    margin: 10px 0 0;
    border-top: 1px solid #e0e0e0;
  }
  @media ${theme.ltMediaQuery.tablet} {
    &.lt-header nav {
      width: auto;
      padding: 0;
      margin: 0 35px 0 0;
      border-top: 0;
    }
  }
  &.lt-header nav a {
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    letter-spacing: 1.1px;
  }
  @media ${theme.ltMediaQuery.tablet} {
    &.lt-header nav a {
      font-size: 16px;
      letter-spacing: 1.7px;
    }
  }
`;
